export default __webpack_public_path__ + "static/media/112-forest.b114666e.jpeg";